import React from 'react';

const IconSprite = () => {
  return (
    <svg width="0" height="0" xmlns="http://www.w3.org/2000/svg">
      <symbol id="logo" viewBox="0 0 22 18.5">
        <polygon points="11,0 0.3,18.5 21.7,18.5 " />
      </symbol>
      <symbol id="flower-top" viewBox="0 0 26.5 24">
        <path
          d="M24.3,9.9L24.3,9.9l-0.1-0.2c0.3-1.7,0-3.5-0.8-5C22,1.8,20,1.2,18.6,1.1h-0.4c-1.7,0-3.2,0.6-4.4,1.8L13.7,3
	H13V2.9c-1.3-1.3-3.1-2-4.9-1.8C6.9,1.1,4.7,1.6,3.2,4.6C2.7,5.9,2.4,7.2,2.4,8.5v0.1L2.4,8.7c-0.9,1-1.5,2.2-1.6,3.6
	C0.5,13.9,1,15.6,2,16.9c1,1.3,2.5,2.1,4.2,2.3h0.3l0.1,0.1c0.9,2,2.7,3.3,4.9,3.8c0.4,0.1,0.8,0.1,1.2,0.1c0.4,0,0.7,0,1.1-0.1
	c1.9-0.3,3.6-1.4,4.6-3l0.1-0.2l0.2,0.1c0.2,0.1,0.4,0.1,0.6,0.1l0,0c1.5,0.2,3.1-0.2,4.3-1.2c1.3-1,2.1-2.5,2.2-4.1
	C26.1,13.1,25.5,11.2,24.3,9.9z M14.4,12l0,0.2h-1c-0.6,0-1.2-0.3-1.5-0.9c-0.3-0.6-0.2-1.2,0.2-1.7c0.2-0.3,0.6-0.4,0.9-0.4h0.2
	c0.4,0,0.8,0.2,1.1,0.6C14.5,10.5,14.6,11.3,14.4,12z M21.7,12.5c-1.1,1.5-2.8,2.5-4.7,2.5c-0.3,0-0.6,0-0.9-0.1
	c-0.9-0.1-1.8-0.4-2.5-0.9l-0.6-0.5h0.8c1.8,0,3.6-0.6,4.9-1.8c1-1,1.4-2.5,1.1-3.9c-0.2-2.1-1.7-3.8-3.6-4.4l-0.7-0.3l0.7-0.2
	c0.8-0.3,1.6-0.4,2.4-0.4l0,0c1.7,0.1,3.1,1.2,3.7,2.8C23.4,7.6,23.1,10.3,21.7,12.5L21.7,12.5z M17.6,10.8c-0.4,0.5-1,0.8-1.6,1
	l-0.3,0.1v-0.4c0.1-0.9,0-1.8-0.4-2.6c-0.4-0.7-1.2-1.1-2-1.2c-1-0.2-1.9,0.2-2.5,1c-0.4,0.6-0.6,1.4-0.5,2.1
	c0.1,2.5,1.9,4.6,4.4,5.2l1,0.3l-1,0.2c-0.5,0.1-0.9,0.1-1.4,0.1c-1.3,0-2.5-0.4-3.5-1.3c-2.2-1.9-2.8-5-1.7-7.6
	c1-2.1,3.1-3.5,5.4-3.4c0.4,0,0.7,0,1.1,0.1l0,0c1.9,0.2,3.5,1.6,3.9,3.5C18.5,9.1,18.2,10.1,17.6,10.8z M10.7,3.6
	c-1.8,0.6-3.2,2-4,3.7c-0.8,2-0.9,4.3-0.1,6.3L7,14.5l-0.7-0.5c-0.7-0.6-1.3-1.3-1.7-2.1c-1-2-1.1-4.4-0.1-6.5
	c0.6-1.6,2-2.6,3.7-2.8C9,2.4,9.9,2.6,10.7,3.1l0.5,0.3L10.7,3.6z M8.4,16l0.4,0.4c0.2,0.1,0.3,0.2,0.5,0.3L9.8,17l-0.5,0.2
	c-0.7,0.4-1.4,0.5-2.2,0.5c-0.2,0-0.4,0-0.7,0l0,0c-1.3,0-2.5-0.6-3.4-1.6c-0.8-1-1.2-2.4-1-3.7c0.1-0.4,0.2-0.8,0.3-1.2l0.2-0.6
	L3,11.3c0.1,0.4,0.3,0.8,0.5,1.1C4.4,14.3,6.2,15.7,8.4,16L8.4,16z M8.5,19.1c0.9-0.2,1.7-0.6,2.4-1.2l0.1-0.1l0.1,0
	c0.6,0.2,1.3,0.3,2,0.3c2.1-0.1,4.1-0.8,5.8-2l0.1,0c1.5-0.5,2.8-1.4,3.7-2.8c0.3-0.4,0.5-0.9,0.7-1.3l0.2-0.4l0.2,0.4
	c0.5,0.9,0.7,1.9,0.6,2.9c-0.2,1.3-0.8,2.4-1.8,3.3c-0.9,0.7-2.1,1.1-3.3,0.9c-0.4-0.1-0.8-0.2-1.1-0.4c-0.1-0.1-0.3-0.1-0.5,0
	c-0.2,0.1-0.3,0.2-0.4,0.4c-0.8,1.8-2.7,3-4.6,3c-0.3,0-0.5,0-0.8-0.1c-1.5-0.2-2.9-1.1-3.7-2.3l-0.2-0.3L8.5,19.1z"
        />
      </symbol>
      <symbol id="flower-bottom" viewBox="0 0 31.5 22">
        <path
          d="M27,4.6c-2.4-0.2-4.9,0.5-6.7,2.1l-1.5,1.1l0.7-1.7c0.5-1.3,1-2.6,1.3-4l0.1-0.3c0.1-0.5-0.6-0.6-0.6-0.7
	c-0.3-0.1-0.9-0.1-1,0.3c-0.9,3.3-2.3,6.5-4.1,9.4L13.7,13c0,0,2-3.1-1.2-7.6c-1.4-1.9-3.5-3.3-5.8-3.9c-0.5,1.3-2.1,7-0.2,10.6
	c0.8,1.5,2.3,2.5,4,2.7l1.1,0.2l-0.9,0.7c-2.6,2-5.7,3.4-9,4c-0.5,0.1-0.5,0.6-0.5,0.9c0.1,0.5,0.4,0.5,0.5,0.5h0.3
	c5.7-1,10.8-4.3,14.1-9.1l0.2-0.3l0.4,0.2c3.6,1.6,6.7,1.6,9.4,0c2.1-1.3,3.6-3.4,4.1-5.7C29.4,5.3,28.2,4.7,27,4.6z M12.8,11.8
	l-0.2,0.4c-0.2,0.5-0.6,0.9-1.1,1.3l-1-0.1c-1.3-0.1-2.4-0.9-2.9-2C6.4,9,7.1,5.2,7.7,3.2c1.6,0.6,3,1.6,3.9,3
	C13.5,8.9,13.2,10.8,12.8,11.8L12.8,11.8z M25.5,10.7c-1,0.7-2.2,1-3.5,1c-1.3,0-2.6-0.3-3.9-0.9c0.8-1.3,1.8-2.4,3-3.3
	c1.3-1.1,3-1.7,4.7-1.8c0.3,0,0.5,0,0.8,0.1c0.7,0.1,1.5,0.4,2.1,0.8C28.1,8.3,27,9.7,25.5,10.7L25.5,10.7z"
        />
      </symbol>
      <symbol id="phone" viewBox="0 0 18 22">
        <path
          d="M4.5,7.8c0.3-0.9,1.7-0.9,2.6-1.6C7.4,6,7.6,5.7,7.6,5.4C7.5,3.8,7.1,2.4,6.6,1C6.4,0.7,6.1,0.5,5.8,0.5
	c-1.4,0-2.7,0.4-3.8,1.3c-5.4,6.4,4.3,21.4,12.5,19.6c1.2-0.6,2.2-1.6,2.9-2.8c0.1-0.3,0-0.6-0.1-0.9c-1.1-1.1-2.3-2-3.6-2.8
	c-0.3-0.1-0.7-0.1-1,0.1c-1,0.5-1.6,1.7-2.6,1.6C8.2,16.2,3.9,9.6,4.5,7.8z"
        />
      </symbol>
    </svg>
  );
};

export default IconSprite;
